<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link class="flex text-indigo-400 group-hover:text-indigo-600" :href="route('roles')">
        <icon name="book" class="w-6 h-9 mr-3 fill-indigo-400 group-hover:fill-indigo-600" /> Papéis /
      </inertia-link>
      <span class="flex ml-1 font-medium">
        {{ form.name }}
      </span>
    </h1>

    <trashed-message v-if="role.deleted_at" class="mb-6" @restore="restore">
      Este papel foi excluído.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2"
                      label="Nome"
          />
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <label>Permissões:</label>&nbsp;
          <ul>
            <li v-for="(option, index) of permissions" :key="index">
              <input
                :id="option['id']"
                v-model="form.selectedPermissions"
                type="checkbox"
                :value="option['id']"
                :name="option['id']"
              />
              <label :for="option['id']">{{ option['name'] }}</label>
            </li>
          </ul>
        </div>
        <br />
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!role.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Deletar Papel
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            Atualizar
            Papel
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {title: this.form.name}
  },
  components: {
    LoadingButton,
    TextInput,
    TrashedMessage,
    Icon,
  },
  layout: Layout,
  props: {
    role: Object,
    permissions: Array,
    rolePermissions: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.role.name,
        selectedPermissions: [],
      }),
    }
  },
  mounted: function () {
    Array.from(Object.keys(this.rolePermissions)).forEach((p) => {
      document.getElementById(p).checked = true

      this.form.selectedPermissions.push(p)
    })
  },
  methods: {
    update() {
      this.form.put(this.route('roles.update', this.role.id))
    },
    destroy() {
      if (confirm('Tem certeza de que deseja excluir este papel?')) {
        this.$inertia.delete(this.route('roles.destroy', this.role.id))
      }
    },
    restore() {
      if (confirm('Tem certeza de que deseja restaurar este papel?')) {
        this.$inertia.put(this.route('roles.restore', this.role.id))
      }
    },
  },
}
</script>
